// extracted by mini-css-extract-plugin
export default {"more":"MarketCount_more--l5K","table":"MarketCount_table--pIN","arrowRight":"MarketCount_arrowRight--mG4","marketCount":"MarketCount_marketCount--UT9"};